import '../../src/App.css';

const Partners = () => {
  return (
    <section className="pt-[64px]" id="partners">
      <div className="mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-16">
          <h2
            className="mb-4 justify-self-center lg:mb-0 lg:mr-8 random-colors-text-partner font-inter font-light text-[44px] sm:text-[58.23px] leading-[60px] sm:leading-[79.49px] tracking-[0px]"
          >
            Network Partners
          </h2>

          <div className="flex flex-col sm:flex-row gap-[40px] sm:gap-[160px] place-self-center mt-[40px] sm:mt-[70px] mb-[50px] sm:mb-[90px]">
            <a href="https://adelphis.co/" target="_blank" rel="noopener noreferrer">
              <div className="flex transition-all duration-300 tracking-wider group">
                <img
                  src="/partner1.png"
                  alt="Adelphis"
                  className="w-[210px] h-[44px]"
                />
                <svg
                  className="ml-[30px] self-center ml-2 transform transition-transform duration-300 group-hover:translate-x-2"
                  width="18"
                  height="16"
                  viewBox="0 0 18 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.7071 8.70711C18.0976 8.31658 18.0976 7.68342 17.7071 7.29289L11.3431 0.928932C10.9526 0.538408 10.3195 0.538408 9.92893 0.928932C9.53841 1.31946 9.53841 1.95262 9.92893 2.34315L15.5858 8L9.92893 13.6569C9.53841 14.0474 9.53841 14.6805 9.92893 15.0711C10.3195 15.4616 10.9526 15.4616 11.3431 15.0711L17.7071 8.70711ZM0 8L0 9H17V8V7L0 7L0 8Z"
                    fill="#6B757D"
                  />
                </svg>
              </div>
            </a>

            <a href="https://www.vtspllc.com/" target="_blank" rel="noopener noreferrer">
              <div className="flex transition-all duration-300 tracking-wider group">
                <img
                  src="/partner2.png"
                  alt="VTSP LLC"
                  className="w-[210px] h-[44px]"
                />
                <svg
                  className="ml-[22px] self-center ml-2 transform transition-transform duration-300 group-hover:translate-x-2"
                  width="18"
                  height="16"
                  viewBox="0 0 18 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.7071 8.70711C18.0976 8.31658 18.0976 7.68342 17.7071 7.29289L11.3431 0.928932C10.9526 0.538408 10.3195 0.538408 9.92893 0.928932C9.53841 1.31946 9.53841 1.95262 9.92893 2.34315L15.5858 8L9.92893 13.6569C9.53841 14.0474 9.53841 14.6805 9.92893 15.0711C10.3195 15.4616 10.9526 15.4616 11.3431 15.0711L17.7071 8.70711ZM0 8L0 9H17V8V7L0 7L0 8Z"
                    fill="#6B757D"
                  />
                </svg>
              </div>
            </a>
          </div>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4">
        </div>
      </div>
    </section>
  );
};

export default Partners;